import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'

export const CheckCanPrintDeliveryReport = ({ ticket }) => {
  const { can_print_delivery_report } = ticket
  let items = []
  can_print_delivery_report.messages.forEach((m) => {
    items.push(
      <ReactBootstrap.Alert key={m} variant="danger">{m}</ReactBootstrap.Alert>
    )
  })
  return <div>{items}</div>
}
